import { useEffect, useRef } from 'react';
import { useLanguage } from '../../context/LanguageContext';

/**
 * Slim, calm status strip.
 *
 * We deliberately do NOT run a countdown timer here, scarcity/urgency clocks are
 * an anti-pattern for premium wellness positioning and conflict with our
 * "transparent, no gimmicks" copy. This bar just anchors two facts
 * (pre-order status, ship window, free NL shipping) in a single quiet line.
 */
export function PreSaleBanner() {
    const { t } = useLanguage();
    const bannerRef = useRef(null);

    // Track banner height as a CSS var so Navbar and pages can offset correctly.
    useEffect(() => {
        const el = bannerRef.current;
        if (!el) return;
        const update = () => {
            document.documentElement.style.setProperty('--banner-h', `${el.offsetHeight}px`);
        };
        update();
        const observer = new ResizeObserver(update);
        observer.observe(el);
        return () => observer.disconnect();
    }, []);

    return (
        <div
            ref={bannerRef}
            className="fixed top-0 left-0 right-0 z-50 bg-primary text-white/90"
            data-testid="presale-banner"
        >
            <div className="section-container">
                <div
                    className="flex flex-row items-center justify-center gap-2 sm:gap-3 py-2 text-[11px] sm:text-xs tracking-wide whitespace-nowrap overflow-hidden"
                    data-testid="presale-banner-content"
                >
                    <span className="font-medium">{t('banner.preorder_label')}</span>
                    <span className="text-white/40" aria-hidden="true">·</span>
                    <span className="text-white/80">{t('banner.ships_line')}</span>
                    <span className="hidden sm:inline text-white/40" aria-hidden="true">·</span>
                    <span className="hidden sm:inline text-white/80">{t('banner.shipping_line')}</span>
                </div>
            </div>
        </div>
    );
}
